/**
 * MyRave's social accounts in the footers — Instagram and Facebook. Drawn
 * unlinked at first (2026-10-10); linked to the real accounts since the user
 * gave them (2026-10-11). Every footer draws this one list — and since 2026-11-02 every MENU too, as "Follow us"
 * (`FollowUs`: a phone has no footer — the user: "they need to be in the menu, Follow us: and just icons ig, fb, and
 * any other social that will be added later"), and the public pages' header. **A new account is ONE row in
 * `MYRAVE_SOCIALS`** (its id, name, address and a 24×24 stroke path) and appears in every one of those places.
 */
import { useT } from '@/i18n';
import './SocialIcons.css';

export const MYRAVE_SOCIALS = [
  {
    id: 'instagram', label: 'Instagram', href: 'https://www.instagram.com/myrave.io',
    d: 'M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zM12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM17.5 6.5h.01',
  },
  {
    id: 'facebook', label: 'Facebook', href: 'https://www.facebook.com/myrave.io/',
    d: 'M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z',
  },
] as const;

export function SocialIcons({ className }: { className?: string }) {
  const tr = useT();
  return (
    <span className={`social-icons${className ? ` ${className}` : ''}`} role="list" aria-label={tr('MyRave on social media')}>
      {MYRAVE_SOCIALS.map((i) => (
        <span key={i.id} role="listitem" className="social-icons-cell">
          <a href={i.href} target="_blank" rel="noopener noreferrer" className="social-icons-item"
            title={tr('MyRave on {network}', { network: i.label })} aria-label={tr('MyRave on {network}', { network: i.label })}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d={i.d} />
            </svg>
          </a>
        </span>
      ))}
    </span>
  );
}

/** "Follow us" and the icons — a menu's foot and the public pages' phone menu (2026-11-02). */
export function FollowUs({ className }: { className?: string }) {
  const tr = useT();
  return (
    <div className={`follow-us${className ? ` ${className}` : ''}`}>
      <span className="follow-us-label">{tr('Follow us')}</span>
      <SocialIcons />
    </div>
  );
}
